import { render, staticRenderFns } from "./searchForDebt.vue?vue&type=template&id=238a4da3"
import script from "./searchForDebt.vue?vue&type=script&lang=js"
export * from "./searchForDebt.vue?vue&type=script&lang=js"
import style0 from "./searchForDebt.vue?vue&type=style&index=0&id=238a4da3&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports